import axios from "axios";

import {
  GET_CLASSSESSION,
  GET_SPLIST,
  GEN_CLASSSESSION,
  DELETE_CLASSSESSION,
  UPDATE_CLASSSESSION,
  RESET_CLASSSESSION,
  LOADING
} from "../actionTypes";
import { DEV_EM_APIS_URL, AWS_SERVER_APIS } from "configurations";
import { adminTokenDev, adminToken } from "../../helper";

const { SET_TRUE, SET_FALSE } = LOADING;

export const get = () => {
  return dispatch => {
    dispatch({ type: SET_TRUE });

    adminToken()
      .then(token =>
        axios.get(
          `${AWS_SERVER_APIS}/get-class-session`,
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
        )
      )
      .then(res => {
        dispatch({ type: GET_CLASSSESSION, payload: res.data.data });
      })
      .catch(err => console.log(err))
      .finally(_ => dispatch({ type: SET_FALSE }));
  };
};

// export const getsplist = () => {
//   return dispatch => {
//     dispatch({ type: SET_TRUE });

//     adminToken()
//       .then(token =>
//         axios.get(
//           `${AWS_SERVER_APIS}/getspbycat`,{
//             "category":'60'
//           },
//           {
//             headers: {
//               Authorization: `Bearer ${token}`
//             }
//           }
//         )
//       )
//       .then(res => {
//         dispatch({ type: GET_SPLIST, payload: res.data.data });
//       })
//       .catch(err => console.log(err))
//       .finally(_ => dispatch({ type: SET_FALSE }));
//   };
// };

export const generate = ({ sub_category_id = "", package_id = "", from_date = "", to_date = "", class_time = ""}) => {
  return dispatch => {
    dispatch({ type: SET_TRUE });

    adminTokenDev()
      .then(token =>
        axios.post(
          `${AWS_SERVER_APIS}/generate-class-session`,
          {
            "sub_category_id":sub_category_id,
            "package_id": `${package_id}`,
            "from_date": `${from_date}`,
            "to_date": `${to_date}`,
            "class_time": `${class_time}`
        },
          
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
        )
      )
      .then(res => {
        alert(res.data.message);
        dispatch(get());
      })
      .catch(err => console.log(err))
      .finally(_ => dispatch({ type: SET_FALSE }));
  };
};

export const update = ({ class_session_id = "", class_date = "", class_time = "", sp_id = "", join_url = "", status = "", enabled = "" }) => {
  return dispatch => {
    dispatch({ type: SET_TRUE });

    adminTokenDev()
      .then(token =>
        axios.post(
          `${AWS_SERVER_APIS}/update-class-session`,
          {
            "class_session_id":class_session_id,
            "class_date": `${class_date}`,
            "class_time": `${class_time}`,
            "sp_id": sp_id,
            "join_url": `${join_url}`,
            "status": `${status}`
        },
          
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
        )
      )
      .then(res => {
        dispatch(get());
      })
      .catch(err => console.log(err))
      .finally(_ => dispatch({ type: SET_FALSE }));
  };
};

export const deletedata = ({ id = ""}) => {
  return dispatch => {
    dispatch({ type: SET_TRUE });

    adminTokenDev()
      .then(token =>
        axios.delete(
        `${AWS_SERVER_APIS}/delete-class-session/${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
        )
      )
      .then(res => {
        dispatch(get());
      })
      .catch(err => console.log(err))
      .finally(_ => dispatch({ type: SET_FALSE }));
  };
};

export const toggleclass = id => {
  return dispatch => {
    dispatch({ type: SET_TRUE });

    adminTokenDev()
      .then(token =>
        axios.post(
        `${AWS_SERVER_APIS}/toggle-class-session`,
          {
            "class_session_id": `${id}`
          },
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
        )
      )
      .then(res => {
        dispatch(get());
      })
      .catch(err => console.log(err))
      .finally(_ => dispatch({ type: SET_FALSE }));
  };
};

export const reset = () => dispatch => dispatch({ type: RESET_CLASSSESSION });
